export const STATIC_REALM_ID = 'dd180bca-465a-470a-abe4-9d5a15ded551';
export const STATIC_USER_ID = '1';

export const STORAGE_KEYS = {
  DASHBOARD_DATA: 'DASHBOARD_DATA',
  PAYMENTS_CONFIG: 'PAYMENTS_CONFIG',
  AUTH_CONFIG: 'AUTH_CONFIG',
  PROFILE: 'profile_information',
  ACCESS_TOKEN: 'access_token',
  WALLET_INFO: 'wallet_information',
  COAPPLICANT_AUTH_CONFIG: 'COAPPLICANT_AUTH_CONFIG',
  CUSTOMER_SUMMARY: 'CUSTOMER_SUMMARY',
  APP_NAME: 'APP_NAME',
  STATE: 'state',
  CUSTOM_DOMAIN: 'customDomain',
  ROUTE: 'route',
  USER_PERSONA: 'USER_PERSONA',
  CALL_BACK_URL: 'CALL_BACK_URL',
  URL_PARAM: 'URL_PARAM'
};

export const EVENTS = {
  LOGIN: 'LOGIN',
  LOGOUT: 'LOGOUT',
  APP_LOAD: 'APP_LOAD'
};

export const PATHS = {
  LENDING_LOANS: '/lending-loans',
  ONBEHALF_OF: '/onbehalfof',
  LOANS: '/loans',
  MY_CUSTOMERS: '/my-customers'
};
